import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import styles from './box-layout.styles';
import Tooltip from "@mui/material/Tooltip";
import { withTranslation } from 'react-i18next';

let nums = Array.from(Array(5).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C', 'D', 'E'];
let BinIds = [];
let deactivatedBin = [];
let IsSaved;

export class MainUnitLayout extends Component {
    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                // if (item) {
                //     deactivatedBin.push(item);
                //     var parentNode = document.getElementById(item).parentNode;
                //     var x = parentNode.classList && parentNode.classList[2];
                //     parentNode.classList.remove(x);
                //     parentNode.style.pointerEvents = 'none';
                //     var items = document.getElementById(item);
                //     items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)';
                //     items.style.color = '#fff';
                // }
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                // if (item) {
                //     var items = document.getElementById(item);
                //     items.style.background = 'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
                //     items.style.color = '#000';
                //     items.style.cursor = 'pointer';
                //     items.style.pointerEvents = 'all';
                // }
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        if (this.props && this.props.BinStatus.length > 0) {
            this.props.BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    // Added by : Manav Pandya
    openbin = (binId, status, pm_id) => {
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            BinIds.map((item) => {
                this.checkIsSaved(item);
                if (this.props.deactivatedBins.includes(item)) {
                    let items = document.getElementById(item);
                    items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)'; // deavtivated
                    items.style.color = '#ffffff'
                } else {
                    if (item !== binId && IsSaved === false) {
                        let items = document.getElementById(item);
                        items.style.background = 'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)'; // available
                    }
                }
                return true
            })
            BinIds = [];
            BinIds.push(binId);
            if (BinIds.length > 0) {
                this.props.Selectedbin(binId, this.props.box_position);
                var items = document.getElementById(binId);
                items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(253, 253, 2) 90%)'; // assigned
                if (this.props.deactivatedBins.includes(binId)) {
                    items.style.color = '#000000';
                }
            }
        }
    }

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }
        const { classes, BinStatus, deactivatedBins, PatientID, ADAData, t } = this.props;
        return (
            <div key={this.props.prefix}>
                <div className={classes.ratingContainer} style={{ marginBottom: '3px' }}>
                    {nums1.map(n1 => {
                        let isdisabledDoor = false;
                        let doorInx = n1 + 1;
                        if (ADAData && ADAData.length > 0) {
                            ADAData.forEach(item => {
                                if (item && item.patient_id === PatientID) {
                                    if (item.ada_compitible === true && (doorInx <= 4 || doorInx >= 9)) {
                                        isdisabledDoor = true;
                                    }
                                }
                            })
                        }
                        return (
                            <Grid
                                key={n1}
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                spacing={8}
                                className={classes.RemoveMargin}
                            >
                                {nums.map(n => {
                                    if ((elem[n] === 'B' || elem[n] === 'C') && (n1 >= 0 && n1 <= 6)) {
                                        if (elem[n] === 'B') {
                                            return <Grid
                                                id={elem[n] + '' + (n1 + 1)}
                                                key={n}
                                                sx={{ cursor: 'pointer', p: '4px', width: '6.3rem' }} />;
                                        } else {
                                            return <Grid
                                                id={elem[n] + '' + (n1 + 1)}
                                                key={n}
                                                sx={{ cursor: 'pointer', p: '4px', width: '6.3rem' }}
                                            />;
                                        }
                                    } else {
                                        if (elem[n] === 'A' || elem[n] === 'B' || elem[n] === 'C') {
                                            if (this.props && this.props.BinStatus && BinStatus.length > 0) {
                                                let BinKey = elem[n] + (n1 + 1)
                                                for (var i = 0; i < BinStatus.length; i++) {
                                                    let pm_id = BinStatus[i].pm_id;
                                                    if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Stocked")}>
                                                                <Grid
                                                                    style={{ padding: '4px' }}
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Stocked', pm_id)}
                                                                    key={BinKey} item xs={3} >
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridOrangeback}
                                                                        style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Assigned")}>
                                                                <Grid
                                                                    style={{ padding: '4px' }}
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                                    key={BinKey} item xs={3}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridBlueback}
                                                                        style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Hold")}>
                                                                <Grid
                                                                    style={{ padding: '4px' }}
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                                    key={BinKey} item xs={3}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridSkyblueback}
                                                                        style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                }
                                                if (deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                    return (
                                                        <Tooltip key={BinKey} title="DEACTIVATE">
                                                            <Grid
                                                                className={classes.deactiveBin}
                                                                style={{ padding: '4px' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={3}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                    style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                                else {
                                                    return (
                                                        <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Available")}>
                                                            <Grid
                                                                id="sms"
                                                                className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                style={{ padding: '4px' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={3}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}
                                                                    style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }

                                            } else {
                                                if (deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {

                                                    return (
                                                        <Tooltip key={((elem[n]) + ' ' + (n1 + 1))} title="DEACTIVATE">
                                                            <Grid
                                                                className={classes.deactiveBin}
                                                                style={{ padding: '4px' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={3}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                    style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                                else {
                                                    return (
                                                        <Tooltip key={((elem[n]) + ' ' + (n1 + 1))} title={t("Global.Prescriptions.Status.Available")}>
                                                            <Grid
                                                                className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                style={{ padding: '4px' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={3}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}
                                                                    style={{ ...[elem[n]].includes('A') ? { width: '6.5rem' } : { width: '5.8rem' } }}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }

                                            }
                                        } else {
                                            if (this.props && this.props.BinStatus && BinStatus.length > 0) {
                                                let BinKey = elem[n] + (n1 + 1)
                                                for (let j = 0; i < BinStatus.length; i++) {
                                                    let pm_id = BinStatus[j].pm_id;
                                                    if (BinStatus[j].type_id === BoxStatus.STOCKED && BinStatus[j].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Stocked")}>
                                                                <Grid
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    style={{ padding: '4px' }}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Stocked', pm_id)}
                                                                    key={BinKey} item xs={2}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridOrangeback}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    else if (BinStatus[j].type_id === BoxStatus.ASSIGNED && BinStatus[j].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Assigned")}>
                                                                <Grid
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    style={{ padding: '4px' }}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                                    key={BinKey} item xs={2}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridBlueback}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    else if (BinStatus[j].type_id === BoxStatus.HOLD && BinStatus[j].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Hold")}>
                                                                <Grid
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    style={{ padding: '4px' }}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                                    key={BinKey} item xs={2}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridSkyblueback} sx={{ width: '6rem' }}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    // else if(BinStatus[j].type_id===BoxStatus.DEACTIVATED && BinStatus[j].bin_id ===  BinKey){
                                                    // return (
                                                    //     <Grid
                                                    //         className={!BinStatus[j].type_id===BoxStatus.DEACTIVATED ? classes.kioskDoor : classes.disabledDoor}
                                                    //         onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                    //         key={n} item xs={2}>
                                                    //             <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                    //                 {elem[n] + ' ' + (n1+1)}
                                                    //             </Paper>
                                                    //         </Grid>
                                                    //     );
                                                    // }
                                                }

                                            }
                                            if (this.props && this.props.BinStatus && BinStatus.length > 0) {
                                                var BinKey = elem[n] + (n1 + 1)
                                                for (let j = 0; j < BinStatus.length; j++) {
                                                    let pm_id = BinStatus[j].pm_id;
                                                    if (BinStatus[j].type_id === BoxStatus.STOCKED && BinStatus[j].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Stocked")}>
                                                                <Grid
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    style={{ padding: '4px' }}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Stocked', pm_id)}
                                                                    key={BinKey} item xs={2}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridOrangeback}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    else if (BinStatus[j].type_id === BoxStatus.ASSIGNED && BinStatus[j].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Assigned")}>
                                                                <Grid
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    style={{ padding: '4px' }}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                                    key={BinKey} item xs={2}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridBlueback}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    else if (BinStatus[j].type_id === BoxStatus.HOLD && BinStatus[j].bin_id === BinKey) {
                                                        return (
                                                            <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Hold")}>
                                                                <Grid
                                                                    className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                                    style={{ padding: '4px' }}
                                                                    onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                                    key={BinKey} item xs={2}>
                                                                    <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridSkyblueback}>
                                                                        {elem[n] + ' ' + (n1 + 1)}
                                                                    </Paper>
                                                                </Grid>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    // else if(BinStatus[j].type_id===BoxStatus.DEACTIVATED && BinStatus[j].bin_id ===  BinKey){
                                                    // return (
                                                    //     <Grid
                                                    //         className={BinStatus[j].type_id===BoxStatus.DEACTIVATED ? classes.kioskDoor : classes.disabledDoor}
                                                    //         onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                    //         key={n} item xs={2}>
                                                    //             <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                    //                 {elem[n] + ' ' + (n1+1)}
                                                    //             </Paper>
                                                    //         </Grid>
                                                    //     );
                                                    // }
                                                }

                                            }
                                            if (deactivatedBins.length > 0 && deactivatedBins.findIndex((D) => D === (elem[n] + (n1 + 1))) > -1) {
                                                return (
                                                    <Tooltip key={((elem[n]) + ' ' + (n1 + 1))} title="DEACTIVATE">
                                                        <Grid
                                                            className={classes.deactiveBin}
                                                            style={{ padding: '4px' }}
                                                            onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                            key={((elem[n]) + ' ' + (n1 + 1))} item xs={2}>
                                                            <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                                {elem[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                            else {
                                                return (
                                                    <Tooltip key={((elem[n]) + ' ' + (n1 + 1))} title={t("Global.Prescriptions.Status.Available")}>
                                                        <Grid
                                                            className={isdisabledDoor === false ? classes.kioskDoor : classes.disabledDoor}
                                                            style={{ padding: '4px' }}
                                                            onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                            key={((elem[n]) + ' ' + (n1 + 1))} item xs={2}>
                                                            <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}>
                                                                {elem[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                    }
                                })}
                            </Grid>
                        );
                    })}
                </div>

            </div>
        );
    }
}

export default withStyles(styles)(withTranslation()(MainUnitLayout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Mainunit-layout.js